<template>
    <div>
        <a-menu :open-keys="aside.openKeys" :selected-keys="aside.selectedKeys" mode="inline" theme="dark"
            @select="select" @openChange="openChange">
            <template v-for="item in aside.menuData">
                <a-menu-item v-if="!item.children && item.ismenu == 1" :key="item.key" @click="changeMenu(item)">
                    <a-icon :type="item.icon" />
                    <span>{{ item.title }}</span>
                </a-menu-item>
                <sub-menu v-else :key="item.key" :menu-info="item" />
            </template>
        </a-menu>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Menu } from "ant-design-vue";
const SubMenu = {
    template: `
      <a-sub-menu v-if="menuInfo.ismenu==1" :key="menuInfo.key" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon :type="menuInfo.icon" /><span>{{ menuInfo.title }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item   v-if="!item.children && item.ismenu==1"" :key="item.key"  @click="changeMenu1(item)">
            <a-icon :type="item.icon" />
            <span>{{ item.title }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.key" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
    name: "SubMenu",
    // must add isSubMenu: true
    isSubMenu: true,
    props: {
        ...Menu.SubMenu.props,
        // Cannot overlap with properties within Menu.SubMenu.props
        menuInfo: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        changeMenu1(item) {
            if (item.name != ""){
                let reversePath = '/'+item.name.split('/').reverse()[0]
                this.$router.push(reversePath);
            }
        },
    },
};
export default {
    data() {
        return {
            collapsed: false
        };
    },
    components: {
        "sub-menu": SubMenu,
    },
    methods: {
        openChange(keys) {
            const aside = { ...this.aside }
            aside.openKeys = keys
            this.changeState({ name: 'aside', value: aside })
        },
        select({ selectedKeys }) {
            const aside = { ...this.aside }
            aside.selectedKeys = selectedKeys
            this.changeState({ name: 'aside', value: aside })
        },
        changeMenu(item) {
            if (item.name != '') {
                this.$router.push(item.name);
            }
        },
        ...mapMutations(['changeState'])
    },
    computed: {
        ...mapState(['aside', 'organizationData'])
    }
};
</script>
